/*
 * @Author: cuixinming
 * @Date: 2021-12-14 13:58:46
 * @Last Modified by: cuixinming
 * @Last Modified time: Do not edit
 * @Description:
 */
import React from "react";
import utils from "../../utils/utils";
import "./style.less";
import shihuo from 'shihuo-lib/dist/shihuo-lib';

class PipelineSenceTab extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isIphoneX: utils.isIphoneX()
    };
    this.pageId = typeof window !== "undefined" ? (window.location.host === "zt-public.shihuo.cn"
      ? window.location.href.indexOf('zt-public.shihuo.cn/stage') > -1
        ? window.location.pathname.split("/")[3]
        : window.location.pathname.split("/")[2]
      : 0) : 0;
  }

  handleImageClick = (href, senceTabIndex, index) => {
    shihuo.uploadTrack({
      from: 'lego-valentineDay',
      block: `tab:${index}`,
      page_id: this.pageId,
      pti: {
        id: `lego-valentineDay:tab:${index}:`,
        pageId: this.pageId,
        page_id: this.pageId,
        tab: senceTabIndex
      }
    });
    const { currentSenceTab } = this.props.config;
    if (currentSenceTab === senceTabIndex) {
      return
    }
    if (utils.isShihuo()) {
      utils.handleItemClick(this.props.routeParams, href);
    } else {
      typeof window !== "undefined" && (window.location.href = href);
    }
  };

  render() {
    const customAttributes = {
      "data-component-id": this.props["data-component-id"],
      "data-component-name": this.props["data-component-name"],
    };

    const { firstTabConfig, secondTabConfig, thirdTabConfig, currentSenceTab } = this.props.config;
    console.log('this.props', this.props);
    return (
      <div
        className={this.state.isIphoneX ? "pipeline-sence-tab isIphoneX" : "pipeline-sence-tab"}
        {...customAttributes}
      >
        <div className="tab">
          <div className={currentSenceTab === '场景1' ? 'sence-tab-1 sence-tab active' : 'sence-tab-1 sence-tab'} onClick={() => this.handleImageClick(firstTabConfig.jumpUrl, '场景1', 0)}>
            {
              currentSenceTab === '场景1' ? <img src={utils.formatImgUrl(firstTabConfig.firstTabHoverBgImage, this.props.webpSupport)} alt="" /> : <img src={utils.formatImgUrl(firstTabConfig.firstTabBgImage, this.props.webpSupport)} alt="" />
            }
          </div>
          <div className={currentSenceTab === '场景2' ? "sence-tab-2 sence-tab active" : "sence-tab-2 sence-tab"} onClick={() => this.handleImageClick(secondTabConfig.jumpUrl, '场景2', 1)}>
            {
              currentSenceTab === '场景2' ? <img src={utils.formatImgUrl(secondTabConfig.secondTabHoverBgImage, this.props.webpSupport)} alt="" /> : <img src={utils.formatImgUrl(secondTabConfig.secondTabBgImage, this.props.webpSupport)} alt="" />
            }
          </div>
          <div className={currentSenceTab === '场景3' ? "sence-tab-3 sence-tab active" : "sence-tab-3 sence-tab"} onClick={() => this.handleImageClick(thirdTabConfig.jumpUrl, '场景3', 2)}>
            {
              currentSenceTab === '场景3' ? <img src={utils.formatImgUrl(thirdTabConfig.thirdTabHoverBgImage, this.props.webpSupport)} alt="" /> : <img src={utils.formatImgUrl(thirdTabConfig.thirdTabBgImage, this.props.webpSupport)} alt="" />
            }
          </div>
        </div>
        {/* <img src="https://static.shihuocdn.cn/admin/files/20220128/502216a5f5ecdd98951d3b531f23718e.png" alt="" className="line" /> */}
      </div>
    );
  }
}

export { PipelineSenceTab };
export default PipelineSenceTab;



// WEBPACK FOOTER //
// ./components/pipeline-sence-tab/index.js